import { render, staticRenderFns } from "./WeiBo.vue?vue&type=template&id=48b6a516&scoped=true"
import script from "./WeiBo.vue?vue&type=script&lang=js"
export * from "./WeiBo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b6a516",
  null
  
)

export default component.exports